import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function ConvertiPreventiviPage() {
  const [gruppi, setGruppi]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore]   = useState('');
  const [sel, setSel]         = useState({});      // ficId -> true
  const [clienteAttivo, setClienteAttivo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [causale, setCausale] = useState('');
  const [note, setNote]       = useState('');
  const [invio, setInvio]     = useState(false);
  const [esito, setEsito]     = useState(null);

  const carica = async () => {
    setLoading(true);
    try {
      const r = await api.get('/preventivi-ddt/convertibili');
      setGruppi(r.data?.data ?? []);
      setErrore('');
    } catch (e) {
      setErrore(e?.response?.data?.error || 'Errore nel caricamento.');
    }
    setLoading(false);
  };
  useEffect(() => { carica(); }, []);

  const toggle = (clienteFicId, ficId) => {
    // selezione consentita su un solo cliente per volta
    if (clienteAttivo && clienteAttivo !== clienteFicId) {
      setSel({ [ficId]: true });
      setClienteAttivo(clienteFicId);
      return;
    }
    const nuovo = { ...sel, [ficId]: !sel[ficId] };
    if (!nuovo[ficId]) delete nuovo[ficId];
    setSel(nuovo);
    setClienteAttivo(Object.keys(nuovo).length ? clienteFicId : null);
  };

  const idsSel = Object.keys(sel).map(Number);

  const componi = async () => {
    setErrore(''); setEsito(null);
    try {
      const r = await api.post('/preventivi-ddt/componi', { ids: idsSel });
      setPreview(r.data?.data);
    } catch (e) {
      setErrore(e?.response?.data?.error || 'Errore nella composizione.');
    }
  };

  const aggiornaRiga = (i, campo, val) => {
    const righe = [...preview.righe];
    righe[i] = { ...righe[i], [campo]: campo === 'descrizione' ? val : Number(val) };
    setPreview({ ...preview, righe });
  };

  const rimuoviRiga = (i) =>
    setPreview({ ...preview, righe: preview.righe.filter((_, j) => j !== i) });

  const conferma = async () => {
    setInvio(true); setErrore('');
    try {
      const rDdt = await api.post('/ddt', {
        cliente_fic_id:    preview.clienteFicId,
        cliente_nome:      preview.clienteNome,
        cliente_indirizzo: preview.clienteIndirizzo,
        cliente_cap:       preview.clienteCap,
        cliente_citta:     preview.clienteCitta,
        data:              preview.data,
        oggetto:           causale,
        note,
        righe: preview.righe,
      });

      // CreateDdt risponde { success, numero, pdfBase64, data: <payload FIC> }
      const risp = rDdt.data || {};
      const ficDoc = risp.data?.data ?? risp.data ?? {};
      const ficDdtId  = ficDoc.id ?? null;
      const ficNumero = risp.numero ?? ficDoc.number ?? null;

      if (!ficDdtId) {
        setEsito({ tipo:'warn', msg:
          'DDT creato su FIC ma non ho ricevuto l\'ID: registra la conversione manualmente.' });
        setInvio(false);
        return;
      }

      try {
        await api.post('/preventivi-ddt/registra', {
          ficDdtId, ficDdtNumero: ficNumero,
          clienteFicId: preview.clienteFicId, ids: idsSel,
        });
        setEsito({ tipo:'ok', msg: `DDT n. ${ficNumero || ficDdtId} creato e collegato.` });
      } catch (e) {
        setEsito({ tipo:'warn', msg:
          `DDT n. ${ficNumero || ficDdtId} creato su FIC, ma la registrazione locale è fallita. ` +
          'I preventivi restano "da convertire": non riconvertirli.' });
      }

      setPreview(null); setSel({}); setClienteAttivo(null);
      setCausale(''); setNote('');
      carica();
    } catch (e) {
      setErrore(e?.response?.data?.error || 'Errore nella creazione del DDT.');
    }
    setInvio(false);
  };

  const totale = preview
    ? preview.righe.reduce((s, r) => s + (r.quantita * r.prezzo * (1 - (r.sconto||0)/100)), 0)
    : 0;

  return (
    <div className="page-content" style={{ padding:24 }}>
      <h2>Converti preventivi in DDT</h2>

      {errore && <div className="alert" style={{ background:'#fee2e2', color:'#991b1b',
        padding:10, borderRadius:6, marginBottom:14 }}>{errore}</div>}
      {esito && <div style={{ background: esito.tipo==='ok' ? '#dcfce7' : '#fef3c7',
        color: esito.tipo==='ok' ? '#166534' : '#92400e',
        padding:10, borderRadius:6, marginBottom:14 }}>{esito.msg}</div>}

      {!preview && (
        <>
          {loading ? <p>Caricamento…</p> : gruppi.length === 0 ? (
            <p style={{ color:'#6b7280' }}>Nessun preventivo accettato da convertire.</p>
          ) : gruppi.map(g => (
            <div key={g.clienteFicId} className="card" style={{ marginBottom:16, padding:16 }}>
              <h4 style={{ margin:'0 0 4px' }}>{g.clienteNome}</h4>
              <div style={{ color:'#6b7280', fontSize:13, marginBottom:10 }}>
                {g.indirizzo} — {g.cap} {g.citta}
              </div>
              {g.preventivi.map(p => (
                <label key={p.ficId} style={{ display:'block', padding:'6px 0',
                  borderTop:'1px solid #f0f0f0' }}>
                  <input type="checkbox" checked={!!sel[p.ficId]}
                    onChange={() => toggle(g.clienteFicId, p.ficId)} />{' '}
                  <strong>N° {p.numero}</strong> del {p.data}
                  {p.oggetto ? ` — ${p.oggetto}` : ''}
                  <span style={{ float:'right', color:'#6b7280' }}>
                    € {Number(p.totale).toFixed(2)}
                  </span>
                </label>
              ))}
            </div>
          ))}

          {idsSel.length > 0 && (
            <button className="btn" onClick={componi} style={{ padding:'10px 20px' }}>
              Componi DDT da {idsSel.length} preventiv{idsSel.length===1?'o':'i'}
            </button>
          )}
        </>
      )}

      {preview && (
        <div className="card" style={{ padding:16 }}>
          <h4 style={{ marginTop:0 }}>{preview.clienteNome}</h4>
          <div style={{ color:'#6b7280', fontSize:13, marginBottom:14 }}>
            {preview.clienteIndirizzo} — {preview.clienteCap} {preview.clienteCitta}
          </div>

          <div style={{ display:'flex', gap:12, marginBottom:14 }}>
            <input placeholder="Causale del trasporto" value={causale}
              onChange={e => setCausale(e.target.value)}
              style={{ flex:2, padding:8 }} />
            <input type="date" value={preview.data}
              onChange={e => setPreview({ ...preview, data: e.target.value })}
              style={{ padding:8 }} />
          </div>

          <table style={{ width:'100%', borderCollapse:'collapse', marginBottom:14 }}>
            <thead>
              <tr style={{ background:'#f3f4f6', textAlign:'left' }}>
                <th style={{ padding:6 }}>Descrizione</th>
                <th style={{ padding:6, width:80 }}>Q.tà</th>
                <th style={{ padding:6, width:100 }}>Prezzo</th>
                <th style={{ padding:6, width:40 }}></th>
              </tr>
            </thead>
            <tbody>
              {preview.righe.map((r, i) => {
                const sep = r.descrizione?.startsWith('—');
                return (
                  <tr key={i} style={{ borderBottom:'1px solid #f0f0f0',
                    background: sep ? '#fafafa' : undefined }}>
                    <td style={{ padding:4 }}>
                      <input value={r.descrizione}
                        onChange={e => aggiornaRiga(i,'descrizione',e.target.value)}
                        style={{ width:'100%', padding:4, border:'1px solid #e5e7eb',
                                 fontStyle: sep ? 'italic' : 'normal' }} />
                    </td>
                    <td style={{ padding:4 }}>
                      {!sep && <input type="number" step="0.01" value={r.quantita}
                        onChange={e => aggiornaRiga(i,'quantita',e.target.value)}
                        style={{ width:'100%', padding:4, border:'1px solid #e5e7eb' }} />}
                    </td>
                    <td style={{ padding:4 }}>
                      {!sep && <input type="number" step="0.01" value={r.prezzo}
                        onChange={e => aggiornaRiga(i,'prezzo',e.target.value)}
                        style={{ width:'100%', padding:4, border:'1px solid #e5e7eb' }} />}
                    </td>
                    <td style={{ padding:4, textAlign:'center' }}>
                      <button onClick={() => rimuoviRiga(i)}
                        style={{ border:'none', background:'none', color:'#dc2626',
                                 cursor:'pointer' }}>✕</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <textarea placeholder="Note" value={note} rows={2}
            onChange={e => setNote(e.target.value)}
            style={{ width:'100%', padding:8, boxSizing:'border-box', marginBottom:14 }} />

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <strong>Totale imponibile: € {totale.toFixed(2)}</strong>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setPreview(null)} disabled={invio}
                style={{ padding:'10px 18px' }}>Indietro</button>
              <button onClick={conferma} disabled={invio}
                style={{ padding:'10px 20px', background:'#16a34a', color:'#fff',
                         border:'none', borderRadius:6 }}>
                {invio ? 'Creazione…' : 'Crea DDT su FIC'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
